import {
  Briefcase,
  Calendar,
  Camera,
  ClipboardList,
  Clock,
  FileText,
  Folder,
  Gift,
  Hash,
  Heart,
  Link,
  List,
  LucideIcon,
  MapPin,
  Megaphone,
  Mic,
  Music,
  Package,
  Phone,
  Shield,
  Sparkles,
  SquareCheck,
  Star,
  Truck,
  Type,
  Users,
  Utensils,
  Wine,
} from "lucide-react";

import type { ChecklistFieldType } from "@/app/_services/ChecklistService";

// Category icons by slug. The server only checks the slug's shape, so new ones need no deploy.
export const CHECKLIST_ICONS: Record<string, LucideIcon> = {
  list: List,
  calendar: Calendar,
  wine: Wine,
  utensils: Utensils,
  mic: Mic,
  music: Music,
  truck: Truck,
  package: Package,
  folder: Folder,
  "file-text": FileText,
  "clipboard-list": ClipboardList,
  star: Star,
  sparkles: Sparkles,
  gift: Gift,
  heart: Heart,
  users: Users,
  camera: Camera,
  megaphone: Megaphone,
  "map-pin": MapPin,
  shield: Shield,
  briefcase: Briefcase,
};

export const DEFAULT_CHECKLIST_ICON = "list";

export function checklistIcon(slug: string | undefined): LucideIcon {
  return (slug && CHECKLIST_ICONS[slug]) || CHECKLIST_ICONS[DEFAULT_CHECKLIST_ICON];
}

export const FIELD_TYPE_ICONS: Record<ChecklistFieldType, LucideIcon> = {
  checkbox: SquareCheck,
  text: Type,
  number: Hash,
  time: Clock,
  date: Calendar,
  select: List,
  phone: Phone,
  url: Link,
};
